import * as types from "../types";

export const auctionListRequest = () => ({
    type: types.FETCH_ALL_AUCTION_LIST_REQUEST
})

export const auctionListSuccess = ({resAuctionList}) => ({
    type: types.FETCH_ALL_AUCTION_LIST_SUCCESS,
    payload:{
        resAuctionList   
    }
})

export const auctionListFailure = ({error}) => ({
    type: types.FETCH_ALL_AUCTION_LIST_FAILURE,
    payload: {
        error: error.message
    }
});

export const auctionListReset = () => ({
    type: types.FETCH_ALL_AUCTION_LIST_RESET,
});
